import { useDispatch, useSelector } from "react-redux";
import CategoryScatter from "./category-scatter";
import "./profitability.scss";
import React, { useState, useEffect, useRef } from "react";
import {
  getRecommendations,
  getSpendShiftData,
} from "../../queries/apiQueries";
import { numberFormatter } from "../../utils";

const Details = (props: any) => {
  const kpiData = props.data;
  const { view, selectedFilters, summaryView, recommended } = props;
  const { isVisible } = props;
  const selectedTimeline = props.selectedTimeline;
  let scatterData: any = [];
  if (kpiData?.scatterData) {
    scatterData = kpiData?.scatterData.map((data: any) => {
      return {
        grossMargin: data.scatterData.grossMargin * 100,
        cagr: data.scatterData.cagr * 100,
        cost: data.cost,
        revenue: data.revenue,
        category: data.category,
        type: data.type,
      };
    });
  }

  const dispatch = useDispatch<any>();
  const [recommendation, setRecommendation] = useState<any>(null);
  const [recommLoading, setRecommLoading] = useState(false);
  const [supplierBenefit, setSupplierBenefit] = useState(0);
  const [totalConsolidatedOpportunity, setTotalConsolidatedOpportunity] =
    useState(0);
  const [l3AndSupplier, setL3AndSupplier] = useState(false);

  useEffect(() => {
    if (view === "Supplier" || view === "L3") {
      setL3AndSupplier(true);
    } else {
      setL3AndSupplier(false);
    }
    if (view === "Supplier") {
      if (selectedFilters?.supplier.length == 1) {
        updateRecommendation(selectedFilters?.supplier[0]);
      }
    } else if (view === "L3") {
      if (selectedFilters?.l3.length == 1) {
        updateRecommendation(selectedFilters?.l3[0]);
      }
    }
  }, [view]);

  useEffect(() => {
    if (view === "Supplier") {
      if (selectedFilters?.supplier.length == 1) {
        updateRecommendation(selectedFilters?.supplier[0]);
      }
    } else if (view === "L3") {
      if (selectedFilters?.l3.length == 1) {
        updateRecommendation(selectedFilters?.l3[0]);
      }
    }
  }, [selectedFilters]);

  const getRecommendation = async (payload: any) => {
    setRecommLoading(true);
    if (payload == null) {
      payload = {
        vendor_name: props?.selectedFilters?.supplier || [],
        l1: props?.selectedFilters?.l1 || [],
        l2: props?.selectedFilters?.l2 || [],
        l3: props?.selectedFilters?.l3 || [],
        district: props?.selectedFilters?.district || [],
      };
      if (props.recommended) {
        if (
          view == "Supplier" &&
          props?.selectedFilters?.supplier.length == 0
        ) {
          payload.vendor_name = [...payload.vendor_name, props.recommended];
        } else {
          if (props?.selectedFilters?.[`${view.toLowerCase()}`].length == 0) {
            payload[view.toLowerCase()] = [
              ...payload[view.toLowerCase()],
              props.recommended,
            ];
          }
        }
      }
    }
    payload.timeline = selectedTimeline;
    let res = await dispatch(getRecommendations(payload));
    setRecommendation(res);
    setRecommLoading(false);
  };

  const getSpendShift = async (payload: any) => {
    if (payload == null) {
      payload = {
        vendor_name: props?.selectedFilters?.supplier || [],
        l1: props?.selectedFilters?.l1 || [],
        l2: props?.selectedFilters?.l2 || [],
        l3: props?.selectedFilters?.l3 || [],
      };
    }
    (payload.timeline = selectedTimeline), (payload.scenario = "base");
    payload.projectType = [];
    payload.supplier = props?.selectedFilters?.supplier || [];
    try {
      let res = await dispatch(getSpendShiftData(payload));
      setSupplierBenefit(
        (res?.incrementalMarginbenefit || 0) + (res?.netNIA || 0)
      );
      setTotalConsolidatedOpportunity(res?.totalConsolidatedOpportunity || 0);
    } catch (error) {
      console.log(error);
    }
  };

  const updateRecommendation = (item: string | null) => {
    props?.updateFilters(item, null);
    setRecommLoading(true);
    props.handleClick(item);
    if (item) {
      // props.recommended = item;
      let payload: any = {
        vendor_name: props?.selectedFilters?.supplier || [],
        l1: props?.selectedFilters?.l1 || [],
        l2: props?.selectedFilters?.l2 || [],
        l3: props?.selectedFilters?.l3 || [],
        district: props?.selectedFilters?.district || [],
      };
      if (view == "Supplier" && props?.selectedFilters?.supplier.length == 0) {
        payload.vendor_name = [...payload.vendor_name, item];
      } else {
        if (props?.selectedFilters?.[`${view.toLowerCase()}`].length == 0) {
          payload[view.toLowerCase()] = [...payload[view.toLowerCase()], item];
        }
      }
      getRecommendation(payload);
      getSpendShift(payload);
    } else {
      setRecommendation(null);
      setRecommLoading(false);
    }
  };

  const handlePageLabelClick = (page: string) => {
    props.updateFilters(props.recommended, page);
  };

  const token = useSelector((state: any) => state.CommonReducer.token);

  useEffect(() => {
    if (token) {
      if (selectedTimeline) {
        if (!props.recommended) {
          setRecommendation(null);
          setRecommLoading(false);
        } else {
          let payload: any = {
            vendor_name: props?.selectedFilters?.supplier || [],
            l1: props?.selectedFilters?.l1 || [],
            l2: props?.selectedFilters?.l2 || [],
            l3: props?.selectedFilters?.l3 || [],
            district: props?.selectedFilters?.district || [],
          };

          if (
            view == "Supplier" &&
            props?.selectedFilters?.supplier.length == 0
          ) {
            payload.vendor_name = [...payload.vendor_name, props.recommended];
          } else {
            if (props?.selectedFilters?.[`${view.toLowerCase()}`].length == 0) {
              payload[view.toLowerCase()] = [
                ...payload[view.toLowerCase()],
                props.recommended,
              ];
            }
          }
          props.updateSummaryFlag(false);
          getRecommendation(payload);
          getSpendShift(payload);
        }
      }
    }
  }, [selectedTimeline]);

  useEffect(() => {
    //    getRecommendation(null);
    if (!props.recommended) {
      setRecommendation(null);
      setRecommLoading(false);
    } else {
      if (props.summaryFlag) {
        let payload: any = {
          vendor_name: props?.selectedFilters?.supplier || [],
          l1: props?.selectedFilters?.l1 || [],
          l2: props?.selectedFilters?.l2 || [],
          l3: props?.selectedFilters?.l3 || [],
          district: props?.selectedFilters?.district || [],
        };

        if (
          view == "Supplier" &&
          props?.selectedFilters?.supplier.length == 0
        ) {
          payload.vendor_name = [...payload.vendor_name, props.recommended];
        } else {
          if (props?.selectedFilters?.[`${view.toLowerCase()}`].length == 0) {
            payload[view.toLowerCase()] = [
              ...payload[view.toLowerCase()],
              props.recommended,
            ];
          }
        }
        props.updateSummaryFlag(false);
        getRecommendation(payload);
        getSpendShift(payload);
      }
    }
  }, [props.recommended]);

  const costOptDesc = (skuCount: number, supplierCount: number) => {
    if (view == "Supplier") {
      return `Negotiate Competitive Net Cost for SKUs procured from ${props.recommended}`;
    } else if (view == "District") {
      return `Negotiate Competitive Net Cost for SKUs procured from ${supplierCount} suppliers within ${props.recommended}`;
    } else if (view == "L1") {
      return `Negotiate Competitive Net Cost for SKUs procured from ${supplierCount} suppliers within ${props.recommended}`;
    } else if (view == "L2") {
      return `Negotiate Competitive Net Cost for SKUs procured from ${supplierCount} suppliers within ${props.recommended}`;
    } else if (view == "L3") {
      return `Negotiate Competitive Net Cost for SKUs procured from ${supplierCount} suppliers within ${props.recommended}`;
    }
  };

  const supplierConsolidationDesc = (additionalOpp: number) => {
    if (view == "Supplier") {
      return `Consolidate ${numberFormatter(
        additionalOpp,
        0,
        "$"
      )} from tail end suppliers to ${
        props.recommended
      } to leverage buying power`;
    } else if (view == "District") {
      return `Consolidate ${numberFormatter(
        additionalOpp,
        0,
        "$"
      )} from tail end suppliers to top suppliers in ${
        props.recommended
      } to leverage buying power`;
    } else if (view == "L1") {
      return `Consolidate ${numberFormatter(
        additionalOpp,
        0,
        "$"
      )} from tail end suppliers to top suppliers in ${
        props.recommended
      } to leverage buying power`;
    } else if (view == "L2") {
      return `Consolidate ${numberFormatter(
        additionalOpp,
        0,
        "$"
      )} from tail end suppliers to top suppliers in ${
        props.recommended
      } to leverage buying power`;
    } else if (view == "L3") {
      return `Consolidate ${numberFormatter(
        additionalOpp,
        0,
        "$"
      )} from tail end suppliers to top suppliers in ${
        props.recommended
      } to leverage buying power`;
    }
  };

  const getDesc = (dashboard: string) => {
    if (scatterData.length > 0 && props.recommended) {
      if (dashboard == "skuSubs") {
        return numberFormatter(
          scatterData.filter((i: any) => i.category == props.recommended)[0]
            .cost * 0.03,
          0,
          "$"
        );
      } else if (dashboard == "gap") {
        return numberFormatter(
          scatterData.filter((i: any) => i.category == props.recommended)[0]
            .cost * 0.01,
          0,
          "$"
        );
      } else if (dashboard == "paymentTerms") {
        return numberFormatter(
          scatterData.filter((i: any) => i.category == props.recommended)[0]
            .cost * 0.002,
          0,
          "$"
        );
      } else if (dashboard == "sellPrice") {
        return numberFormatter(
          scatterData.filter((i: any) => i.category == props.recommended)[0]
            .cost * 0.028,
          0,
          "$"
        );
      } else if (dashboard == "crossSell") {
        return numberFormatter(
          scatterData.filter((i: any) => i.category == props.recommended)[0]
            .cost * 0.019,
          0,
          "$"
        );
      } else {
        return "-";
      }
    } else {
      return "-";
    }
  };

  return (
    <>
      <div
        className={`summary-flex mx-[1vw] ${
          isVisible ? "h-[36vh]" : "h-[48vh]"
        }`}
      >
        <div
          className="scatter relative gap-3 box-shadow-card w-1/3"
          style={{
            border: "0.5px solid #bebebe",
            height: isVisible ? "36vh" : "48vh",
          }}
        >
          <CategoryScatter
            data={scatterData}
            text="SUMMARY"
            summaryView={summaryView}
            refX={props.data.cagr * 100}
            refY={props.data.grossMargin * 100}
            view={props.view}
            recommended={props.recommended}
            handleClick={(selected: string | null) => {
              props.handleClick(selected); // Call parent handler
              updateRecommendation(selected); // Handle recommendation
            }}
            highlight={props.highlight}
            style={{ height: "100%", width: "100%" }}
          />
        </div>

        {recommLoading ? (
          <div className="loaderCustom w-[67vw]"></div>
        ) : recommendation ? (
          <div className="w-[67vw] flex justify-start ml-[1vw] items-start overflow-y-auto">
            <div className="flex flex-col items-center w-full">
              <span className=" headerText title flex justify-start items-end  font-bold text-black pt-0  w-full mb-[0.4vh]">
                Opportunities by Different Levers{" "}
                {recommended ? `for ${recommended}` : ""}
              </span>
              <div className="flex flex-col justify-start w-full py-[1vh]">
                <span className="title flex justify-start  headerText font-bold pb-[1vh]  w-full">
                  Strategic Sourcing
                </span>

                <div className="flex flex-row justify-start items-start gap-x-[1vw] grow w-full sizeText">
                  <div className="flex flex-col gap-y-[0.8vh] w-full">
                    <div
                      className={`flex flex-col 
													 basis-[12vh]
											 w-full grow border-[1px] border-[gray]`}
                    >
                      <div
                        className="border-b-2 cursor-pointer border-[#86BC25] p-[1%]  bg-[#ffff] text-black font-bold text-left"
                        onClick={() => {
                          handlePageLabelClick("/supplier-consolidation");
                        }}
                      >
                        Supplier Consolidation
                      </div>
                      <div className="flex justify-between items-center pl-[2%] h-full bg-[#EFF6E1]">
                        {recommendation?.supplierConsolidation && (
                          <>
                            <span className="basis-[85%]  text-black">
                              {supplierConsolidationDesc(
                                recommendation.supplierConsolidation
                                  .additionalOpportunity
                              )}
                            </span>
                            <span className="flex items-center justify-center border-[#494444b3] h-full basis-[15%] text-[1.4vh] text-black">
                              {numberFormatter(
                                recommendation.supplierConsolidation
                                  .opportunity,
                                0,
                                "$"
                              )}
                            </span>
                          </>
                        )}
                      </div>
                    </div>

                    <div
                      className={`flex flex-col 
													 basis-[12vh]
											 w-full grow border-[1px] border-[gray]`}
                    >
                      <div
                        className="border-b-2 cursor-pointer border-[#86BC25] text-left p-[1%]  bg-[#ffff] text-black font-bold"
                        onClick={() => {
                          handlePageLabelClick("/cost-optimization");
                        }}
                      >
                        Cost Optimization
                      </div>
                      <div className="flex justify-between items-center pl-[2%] h-full bg-[#EFF6E1]">
                        <span className="basis-[85%] text-black">
                          {costOptDesc(
                            recommendation.costOptimization.materialCount,
                            recommendation.costOptimization.supplierCount
                          )}
                        </span>
                        <span className="flex items-center justify-center border-[#494444b3] h-full basis-[15%]  text-black">
                          {numberFormatter(
                            recommendation.costOptimization.opportunity,
                            0,
                            "$"
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-y-[0.8vh] w-full">
                    <div
                      className={`flex flex-col 
													 basis-[12vh]
											 w-full grow border-[1px] border-[gray]`}
                    >
                      <div
                        className="border-b-2 cursor-pointer border-[#86BC25] text-left p-[1%]  bg-[#ffff] text-black font-bold"
                        onClick={() => {
                          handlePageLabelClick("/nia-negotiations");
                        }}
                      >
                        NIA Negotiations
                      </div>
                      {recommendation?.nia && (
                        <div className="flex justify-between items-center pl-[2%] h-full bg-[#EFF6E1]">
                          <span className="basis-[85%]  text-black">
                            {props.view == "Supplier"
                              ? `Negotiate a ${numberFormatter(
                                  recommendation.nia.rebateIncrease * 100,
                                  2
                                )}% raise in rebate with ${props.recommended}`
                              : `Negotiate better rebate terms with ${recommendation.nia.supplierCount} suppliers`}
                          </span>
                          <span className="flex items-center justify-center border-[#494444b3] h-full basis-[15%]  text-black">
                            {numberFormatter(
                              recommendation.nia.opportunity,
                              0,
                              "$"
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col justify-start  w-full py-[1vh]">
                <span className="title flex justify-start   headerText font-bold w-full pb-[1vh]">
                  Assortment & Product
                </span>

                <div className="flex flex-row justify-start items-start gap-x-[1vw] grow w-full sizeText">
                  <div className="flex flex-col gap-y-[0.8vh] w-full">
                    <div
                      className={`flex flex-col 
													 basis-[12vh]
											 w-full grow border-[1px] border-[gray]`}
                    >
                      <div
                        className="border-b-2 cursor-pointer border-[#86BC25] p-[1%]  bg-[#ffff] text-black font-bold text-left"
                        onClick={() => {
                          handlePageLabelClick("/sku-management");
                        }}
                      >
                        SKU Substitution
                      </div>
                      <div className="flex justify-between items-center pl-[2%] h-full bg-[#EFF6E1]">
                        <span className="basis-[85%]  text-black">
                          Substitute{" "}
                          {recommendation.skuSubstitute.skuSubstituteCount
                            ? recommendation.skuSubstitute.skuSubstituteCount
                            : "0"}{" "}
                          lower margin SKUs to optimize margin
                        </span>
                        <span className="flex items-center justify-center border-[#494444b3] h-full basis-[15%] text-black">
                          {recommendation.skuSubstitute.skuSubstituteOpportunity
                            ? numberFormatter(
                                recommendation.skuSubstitute
                                  .skuSubstituteOpportunity,
                                0,
                                "$"
                              )
                            : "$0"}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col gap-y-[0.8vh] w-full">
                    <div
                      className={`flex flex-col 
													 basis-[12vh]
											 w-full grow border-[1px] border-[gray]`}
                    >
                      <div
                        className="border-b-2 cursor-pointer border-[#86BC25] text-left p-[1%]  bg-[#ffff] text-black font-bold"
                        onClick={() => {
                          handlePageLabelClick("/portfolio");
                        }}
                      >
                        Portfolio Gap
                      </div>
                      <div className="flex justify-between items-center pl-[2%] h-full bg-[#EFF6E1]">
                        <span className="basis-[85%]  text-black">
                          Add{" "}
                          {recommendation.portfoliogap.portFolioCount
                            ? recommendation.portfoliogap.portFolioCount
                            : "0"}{" "}
                          high-profitability items which are sold in other
                          districts to fill portfolio gaps
                        </span>
                        <span className="flex items-center justify-center border-[#494444b3] h-full basis-[15%]  text-black">
                          {recommendation.portfoliogap.portfolioBenefit
                            ? numberFormatter(
                                recommendation.portfoliogap.portfolioBenefit,
                                0,
                                "$"
                              )
                            : "$0"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="flex flex-col justify-start  w-full py-[1vh]">
                <div className="flex flex-col  w-full">
                  <span className="title flex justify-start items-center  headerText text-black w-full pb-[1vh]">
                    Commercial & Sell Price Optimization
                  </span>

                  <div className="flex flex-row justify-start items-start gap-x-[1vw] grow w-full sizeText">
                    <div className="flex flex-col gap-y-[0.8vh] w-full">
                      <div
                        className={`flex flex-col 
													 basis-[12vh]
											 w-[50%] grow border-[1px] border-[gray]`}
                      >
                        <div
                          className="border-b-2 cursor-pointer border-[#86BC25] text-left p-[1%]  bg-[#ffff] text-black font-bold"
                          onClick={() => {
                            handlePageLabelClick("/pricing");
                          }}
                        >
                          Commercial Optimization
                        </div>
                        <div className="flex justify-between items-center pl-[2%] h-full bg-[#EFF6E1]">
                          <span className="basis-[85%]  text-black">
                            Maintain Target Sell Price for{" "}
                            {recommendation?.pricing?.skuCount} SKUs for
                            customers whose current price is significantly lower
                            than Target price for all transactions
                          </span>
                          <span className="flex items-center justify-center border-[#494444b3] h-full basis-[15%]  text-black">
                            {recommendation?.pricing?.projectedOpportunity
                              ? numberFormatter(
                                  recommendation?.pricing?.projectedOpportunity,
                                  0,
                                  "$"
                                )
                              : "$0"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex justify-center items-center basis-[60vw]">
            {l3AndSupplier && (
              <span className="text-[2.5vh] font-normal italic text-[#000]">
                Please select the {view} from left side to view the
                recommendations
              </span>
            )}
            {!l3AndSupplier && (
              <span className="text-[2.5vh] font-normal italic text-[#000]">
                Please select Supplier/L3 to view the recommendations
              </span>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default Details;
